import React from 'react';
import { KeyRound } from 'lucide-react';

/**
 * Логотип провайдера входа.
 *
 * <p>Набор здесь - только про рисование. Какие провайдеры показывать, решает сервер
 * (`/api/auth/social-providers`), поэтому провайдер, логотипа которому тут ещё нет,
 * получает нейтральный значок, а не пропадает из списка.
 */
const ICONS = {
    google: (size) => (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
        </svg>
    ),
    yandex: (size) => <img src={`${process.env.PUBLIC_URL || ''}/yandex_logo.svg`} width={size} height={size} alt="" aria-hidden="true" style={{ objectFit: 'contain', flexShrink: 0 }} />,
    vk: (size) => <img src={`${process.env.PUBLIC_URL || ''}/vk_logo.svg`} width={size} height={size} alt="" aria-hidden="true" style={{ objectFit: 'contain', flexShrink: 0 }} />,
    telegram: (size) => (
        <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="#29A9EB" />
            <path fill="#fff" d="M17.6 7.3 15.7 17c-.1.6-.5.8-1 .5l-2.8-2-1.3 1.3c-.2.2-.3.3-.6.3l.2-3 5.3-4.8c.2-.2 0-.3-.4-.1L8.5 12.2l-2.8-.9c-.6-.2-.6-.6.1-.9l11-4.2c.5-.2.9.1.8.9z" />
        </svg>
    ),
};

const SocialIcon = ({ provider, size = 18 }) => {
    const draw = ICONS[(provider || '').toLowerCase()];
    if (draw) return draw(size);
    return <KeyRound size={size} className="text-gray-500" />;
};

export default SocialIcon;
